import { createContext } from "react";

const ThemeMapContext = createContext({});

export default ThemeMapContext;
